import { ApiRequester } from "../ApiRequester"

interface RequestDataShape {
	id: string
}

export async function committeeMemberDeleteApi(payload: RequestDataShape, token: string) {
	const endpoint = "/committee/member/delete/v1"
	const requester = new ApiRequester<RequestDataShape, void>(endpoint)
	await requester.sendRequest(payload, token)
}
